import React, { Fragment, useState} from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import "../css/cart.css";
import TablaProductos from './TablaProductos';

export default function ProductosVariables(props) {
  const { idProducto, addProductCart, left, top, width, height} = props;
    const [open, setOpen] = useState(false);

    const handleClickOpen = () =>{
      setOpen(true);
    
    }
    const handleClose = () => {
      setOpen(false);
    };
      return (
        <Fragment>
    
            <button 
              className="image_wrapper"
              style={{ left: left, top: top, width: width, height: height  }}
              onClick={handleClickOpen}
            >
            
           
          </button>
          
        
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
          <DialogTitle id="alert-dialog-title">{"Escoje una Opción"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <TablaProductos idProducto={idProducto} addProductCart={addProductCart}/>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="danger">
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
       
        </Fragment>
      );
}
